import { InfoPopover, Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { PlotReportFactElement } from '@/api/rest/resources/types/fact';
import { ChartHeading } from '@/components/Charts/components/ChartHeading';
import { ProtectedAreasChart } from '@/components/Charts/ProtectedAreas';
import { useMapRadiusContext } from '@/components/MapOverview/components/MapRadiusContextProvider';
import { useProtectedAreasMethodology } from '@/hooks/useProtectedAreasMethodology';

import { NoPlotData } from '../NoPlotData';

export const ProtectedAreasGraphTile = ({ protectedAreas }: { protectedAreas: PlotReportFactElement[] }) => {
  const { t } = useTranslation();
  const { radius } = useMapRadiusContext();

  const { hasIbat } = useProtectedAreasMethodology();

  const noChartData = protectedAreas.length === 0;

  if (noChartData) {
    return <NoPlotData />;
  }

  const graphTitlte = t(
    hasIbat
      ? 'shared.ncaDetail.details.protectedAreas.labels.graphHeadlineIbat'
      : 'shared.ncaDetail.details.protectedAreas.labels.graphHeadlineOsm',
    {
      radius,
    },
  );

  const graphTooltip = t(
    hasIbat
      ? 'shared.ncaDetail.details.protectedAreas.labels.graphHeadlineIbatTooltip'
      : 'shared.ncaDetail.details.protectedAreas.labels.graphHeadlineOsmTooltip',
  );

  return (
    <Stack center data-testid='protected-areas-graph-tile'>
      <Stack spacing={2.5} className='w-full items-center justify-center px-1 py-6 lg:items-start lg:p-8 lg:pl-1'>
        <ChartHeading
          heading={graphTitlte}
          popover={
            <InfoPopover
              title={graphTitlte}
              body={graphTooltip}
              popoverTriggerProps={{
                className: 'text-text-secondary',
              }}
            />
          }
          className='w-full px-6 sm:px-0'
        />
        <ProtectedAreasChart data={protectedAreas} data-testid='protected-areas-chart' />
      </Stack>
    </Stack>
  );
};
